import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Table} from 'react-bootstrap';
import swal from 'sweetalert';
import moment from 'moment';
import SvgIcon from 'react-icons-kit';
import {bin} from 'react-icons-kit/icomoon/bin';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import Help from '../../generics/help';

var Config = require('../../../config');
var session = sessionStorage.getItem('health_facilities_name');

class ListModify extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.newEntry = this.newEntry.bind(this);
		this.getList = this.getList.bind(this);
		this.onDelete = this.onDelete.bind(this);

		var aux_date = new Date();
		this.state = {
			filterText:"",
			start_date:aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
			end_date:aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
			list:[],
		}
	}

	componentDidMount(){

		this.getList();

	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});
	}

	newEntry(){
		this.props.history.push("/modify_component/new");
	}

	getList(){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'transformation_process?start_date='+this.state.start_date+
			'&end_date='+this.state.end_date+'&health_facilities_id='+sessionStorage.getItem('health_facilities_id'),{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json()
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({list:response});
			}
		});
	}



	filter(row){
		var res = true;

		if(row !== null){
			if(row.process !== null){
				if(
					row.process.indexOf(this.state.filterText.toUpperCase()) !== -1 					
				){
					res = true;
				}else{
					res = false;
				}
			}
		}

		return res;
	}

	onDelete(id){
		swal({
	        title: '¿Está seguro?',
	        text: '¿Seleccione una opción?',
	        type: 'warning',
	        showCancelButton: true,
	        confirmButtonColor: '#DD6B55',
	        confirmButtonText: 'Eliminar!',
	        cancelButtonText: '¡Cancelar!',
	        closeOnConfirm: true,
	        closeOnCancel: true
	    },  (isConfirm)=> {
	        if (isConfirm) {
	        	this.props.waiting.handleShow('Eliminando...');
				fetch(Config.default.apiGateway.URL+'transformation_process/'+id, {
		  			method : 'delete',
		  			headers: new Headers({
		  				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
		  				'Accept'		: 'application/json',
		  				'Content-Type'	: 'application/json'
		  			})
		  		}).then(res => {
		  			this.props.waiting.handleClose();
		  			if(res.ok){
		  				return res.json();
		  			}else{
		  				res.text().then((msg)=>{
		  					swal("Error", msg, 'error');
		  				})
		  			}
		  		})
		  		.then(response=>{
		  			if(response !== undefined){
		  				this.getList();
		  				swal('Success', 'El registro se elimino correctamente', 'success');
		  			}	
		  		})
	        }
	    });
	}



	render(){
		const {t} = this.props;

		return(
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{session} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.process.MAIN')} ->
						{'Listado '+ t('sidebar.nav.process.modify_component.MAIN')}

					</h5>
				</div>
				<Help 
					{...this.props}
	                menu={"help_processed"} 
	                submenu={"help_transformation"}  />
				<form noValidate>
					<div className="col-xs-12">
						<div className="col-xs-12 col-md-3" style={{padding:'0'}}>
				            <div className="col-xs-12 col-sm-5">
				            	<span className="span-min">Mostrar Desde</span>
				            </div>
				            <div className="col-xs-12 col-sm-7">
				              <input className="form-control" type="date" name="start_date" value={this.state.start_date}
				                onChange={this.handleChange}/>
				            </div>
				        </div>
				        <div className="col-xs-12 col-md-3">
				            <div className="col-xs-12 col-sm-5">
				            	<span className="span-min">Mostrar Hasta</span>
				            </div>
				            <div className="col-xs-12 col-sm-7">
				              <input className="form-control" type="date" name="end_date" value={this.state.end_date}
				                onChange={this.handleChange}/>
				            </div>
				        </div>
						<div className="col-xs-12 col-sm-4">
							<button type="button" className="btn btn-info" onClick={this.getList} 
								style={{fontSize:"14px", marginRight:"5px"}}
								>
								Buscar
							</button>
							<button type="button" className="btn btn-info" onClick={this.newEntry} 
								style={{fontSize:"14px"}}
								disabled={!this.props.task_pools.create}>
								Nuevo
							</button>
						</div>
						
					</div>
					<div className="col-xs-12 form-group">
						<div className="col-xs-12 col-sm-3">
							<input type="text" className="form-control" placeholder="Filtro..." name="filterText" 
								id="filterText" value={this.state.filterText} onChange={this.handleChange} />
						</div>
					</div>
					<div className="col-xs-12">
						<Table responsive>
							<thead>
								<tr>
									<th>Fecha</th>
									<th>Hora</th>
									<th>Proceso</th>
									<th>Unidades</th>
									<th></th>
								</tr>
							</thead>
							<tbody>
								{this.state.list.map((l, i)=>(
									this.filter(l) ? 
										<tr key={i}>
											<td>{moment(l.date).format('DD/MM/YYYY')}</td>
											<td>{moment(l.hour, 'H:mm:ss').format('HH:mm')}</td>
											<td>{l.process}</td>
											<td>
												{l.units.map((u, j)=>(
													u+(j === l.units.length - 1 ? '' : ', ')
												))}
											</td>
											<td>
												<FloatingActionButton backgroundColor={'#ededed'} mini={true} style={{marginLeft:"5px"}} 
													iconStyle={{height: 33, width: 33}}
													onClick={(e)=> this.onDelete(l.id)}>
													<SvgIcon icon={bin} className="icon-align" />
												</FloatingActionButton>
											</td>
										</tr>
									: null
								))}

							</tbody>
						</Table>
					</div>

				</form>

			</div>
		)
	}
}

export default translate('translations')(ListModify);